import React from 'react'
import { useParams } from 'react-router-dom'
import { useApp } from './hooks/useApp'
import { Spinner } from '../../../helpers/commonUi'
import { CreateApp } from './CreateApp'

export const EditApp = () => {
  const params: { appId: string } = useParams()
  const { appId } = params
  const { loading, app } = useApp(appId)

  if (loading) {
    return <Spinner />
  }

  return <CreateApp edit={true} editData={app} />
}
